var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape2Tl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 1766,
    viewBox: "0 0 244 1766",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7276 237.899L170.77 265.09L-127.833 823.746L-94.6398 1456.33L-216.682 1429.14L-249.875 796.554L48.7276 237.899Z",
    fill: "#D9166F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1721 -104.739L242.922 -63.3535L-215.412 804.214L-168.747 1784.34L-354.497 1742.96L-401.162 762.828L57.1721 -104.739Z",
    fill: "url(#paint0_radial_16648_125590)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16648_125590",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-180.973 811.91) rotate(-167.44) scale(193.47 1159.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2Tl);
export default __webpack_public_path__ + "static/media/shape2TL.dd85b1e6c679a25c1a9c8ad1019125c8.svg";
export { ForwardRef as ReactComponent };